module.exports = __webpack_public_path__ + "img/underline_large.b99fd648.svg";